export const PLACEHOLDER = {
  PH_FULL_NAME: 'Full Name',
  PH_EMPLOYEE_ROLE: 'Employee Role',
  PH_EMPLOYEE_CODE: 'Employee Code',
  PH_EMAIL_INPUT: 'Enter Email',
  PH_FIRST_NAME: 'First Name',
  PH_LAST_NAME: 'Last Name',
  PH_MOBILE: 'Mobile',
  PH_EMAIL: 'Email',
  PH_NAME: 'Name',
  PH_DEPARTMENT_LEAD: 'Department Lead',
  PH_USER: 'User',
  PH_LEAVE_TYPE: 'Leave Type',
  PH_AVAILABLE_BALANCE: 'Available Balance',
  PH_BOOKED_BALANCE: 'Booked Balance',
  PH_LEAVE_REASON: 'Leave Reason',
  PH_HOLIDAY_NAME: 'Holiday Name',
  PH_HOLIDAY_DATE: 'Holiday Date',
  PH_SELECT_USER: 'Select User',
  PH_SELECT_LEAVE_TYPE: 'Select Leave Type',
  PH_SELECT_LEAD: 'Select Department Lead',
  PH_HOLIDAY_DESCRIPTION: 'Holiday Description',
  PH_NATIONALITY: 'Please Select Nationality',
  PH_SOURCE_HIRE: 'Please Select Source Of Hire',
  PH_SEARCH_INPUT: 'Search...',
  PH_MORE: 'more',
  PH_AND: 'and',
  PH_REPORTING_MANAGER: 'Select Project Manager',
  PH_EXISTING_BALANCE: 'Existing Balance',
  PH_LAPTOP: 'Laptop',
  PH_ASSETS_FIELD_NAME: 'e.g. Docking Station',
  PH_NEW_BALANCE: 'New Balance',
  PH_NO_FILES: 'No Files Uploaded yet',
  PH_SUPPORT_TICKET_REASON: 'Enter Reason',
  PH_COMPLAIN_TICKET_REASON: 'Enter Description',
  PH_CORRECTION_LOP: 'Enter Corrected LOP',
  PH_LOP: 'Enter LOP',
  PH_CORRECTION_NOTES: 'Enter Notes',
  PH_OVERTIME: 'Enter Overtime',
  PH_CORRECTION_OVERTIME: 'Enter Corrected Overtime',
  PH_LOP_OVERTIME_REASON: 'Enter a Reason',
  PH_LOP_OVERTIME_DAYS: 'Enter Days'
};

export const INPUT_LABEL = {
  LB_EMPLOYEE_ROLE: ' Employee Role',
  LB_TBL_COL_LEAVE_TYPE: 'Select Leave Type',
  LB_TBL_COL_FROM_DATE: 'From Date',
  LB_TBL_COL_TO_DATA: 'To Date',
  LB_LEAVE_REASON: 'Leave Reason',
  LB_EMPLOYEE_PROFILE_IMAGE: 'Employee Profile Image',
  LB_CODE: 'Code',
  LB_TYPE: 'Type',
  LB_BALANCE: 'Balance Based On',
  LB_ENTITLEMENT: 'Entitlement',
  LB_GRANT: 'Grant',
  LB_NAME: 'Name',
  LB_AVG: 'Average',
  LB_NOTES: 'Notes',
  LB_DESCRIPTION: 'Description',
  LB_START_DATE: 'Start Date',
  LB_HOLIDAY_NAME: 'Holiday Name',
  LB_HOLIDAY_DATE: 'Holiday Date',
  LB_HOLIDAY_DESCRIPTION: 'Holiday Description',
  LB_DEPARTMENT_LEAD: 'Department Lead',
  LB_FIRST_NAME: 'First Name',
  LB_LAST_NAME: 'Last Name',
  LB_EMAIL: 'Email',
  LB_COM_EMAIL: 'Company Email',
  LB_MOBILE: 'Mobile',
  LB_ROLE: 'Role',
  LB_AVAILABLE_BALANCE_INPUT: 'Available Balance',
  LB_BOOKED_BALANCE_INPUT: 'Booked Balance',
  LB_TBL_COL_LEAVE_TYPE_INPUT: 'Leave Type',
  LB_USER: 'User',
  LB_ASSETS_FIELD_NAME: 'Assets field name',
  LB_GENDER_LABEL: 'Gender',
  LB_DEPARTMENT_LABEL: 'Department',
  LB_LB_EMPLOYEE: 'Employee',
  LB_MARITAL_STATUS_LABEL: 'Marital Status',
  LB_DESIGNATION_LABEL: 'Designation',
  LB_EFFECTIVE_AFTER: 'Effective After',
  LB_NO_DAYS: 'No. of Days',
  LB_ACCRUAL: 'Accrual',
  LB_TBL_COL_FROM: 'From',
  LB_IN: 'in',
  LB_APPLICABLE: 'Applicable',
  LB_GENDER: ' Select Gender',
  LB_DEPARTMENT: ' Select Department',
  LB_EMPLOYEE: ' Select Employee',
  LB_MARITAL: ' Select Marital Status',
  LB_DESIGNATION: ' Select Designation',
  LB_DELETE_LEAVE_TYPE: 'Delete Leave Type',
  LB_DATE_OF_JOINING: 'Date of Joining',
  LB_DOB: 'Date of Birth',
  LB_EMERGENCY_MOBILE: 'Emergency Mobile',
  LB_PERSONAL_EMAIL: 'Personal Email',
  LB_ADDRESS: 'Address',
  LB_NATIONALITY: 'Nationality',
  LB_SOURCE_HR: 'Source of Hire',
  LB_REPORTING_MANAGER: 'Project Manager',
  LB_REPORTING_TL: 'Reporting Team Lead',
  LB_EMPLOYEE_TYPE: 'Employee Type',
  LB_COMPANY_ADDRESS: 'Company Address',
  LB_WORK: 'Work Information',
  LB_PERSONAL_INFORMATION: 'Personal Information',
  LB_WORK_EXPERIENCE: 'Work Experience',
  LB_EDUCATION_DETAIL: 'Education Detail',
  LB_ADD_EXPERIENCE: 'Add Experience',
  LB_ADD_EDUCATION: 'Add Education',
  LB_COMPANY_NAME: 'Company Name',
  LB_JOB_TITLE: 'Job Title',
  LB_FROM_DATE: 'From Date',
  LB_TO_DATE: 'To Date',
  LB_ACTION: 'Action',
  LB_INSTITUTE_NAME: 'Institute Name',
  LB_DEGREE: 'Degree',
  LB_SPECIALIZATION: 'Specialization',
  LB_DATE_COMPLETION: 'Date Of Completion',
  LB_DELETE_LEAVE_MESSAGE: 'Are you sure you want to Delete Leave Type ?',
  LB_FULL_NAME: 'Full Name',
  LB_EMPLOYEE_CODE: 'Employee Code',
  LB_EFFECTIVE_START: 'Effective Start Date',
  LB_EFFECTIVE_END: 'Effective End Date',
  LB_CARRY_FORWARD: 'Carry Forward',
  LB_NO_OF_DAYS: 'No of Days',
  LB_PER: 'per',
  LB_FROM: 'from',
  LB_OR: '(OR)',
  LB_DELETE_KPI: 'Delete KPI',
  LB_DELETE_KPI_MESSAGE: 'Are you sure you want to Delete KPI ?',
  LB_SUPPORT_TICKET_REASON: 'Reason',
  LB_COMPLAIN_TICKET_REASON: 'Description',
  LB_POINTS: 'Points',
  LB_CORRECTION_LOP: 'Corrected LOP',
  LB_LOP: 'LOP',
  LB_CORRECTION_NOTES: 'Notes',
  LB_OVERTIME: 'Overtime',
  LB_CORRECTION_OVERTIME: 'Corrected Overtime',
  LB_DELETE_LOP_OVERTIME: 'Delete LOP or Overtime Request',
  LB_DELETE_LOP_OVERTIME_MESSAGE: 'Are you sure you want to Delete LOP or Overtime Request ?',
  LB_LOP_OVERTIME_REASON: 'LOP or Overtime Reason',
  LB_LOP_OVERTIME_DAYS: 'Days',
  LB_LOP_OVERTIME_CLAIM_DATE: 'Claim Date',
  LB_LOP_OVERTIME_TYPE: 'Type'
};

export const GENDER_OPTION = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' }
];

export const MARITAL_STATUS_OPTION = [
  { value: 'Single', label: 'Single' },
  { value: 'Married', label: 'Married' }
];

export const SOURCE_OF_HIRE = [
  { value: 'Direct', label: 'Direct' },
  { value: 'Referral', label: 'Referral' },
  { value: 'Web', label: 'Web' },
  { value: 'LinkedIn', label: 'LinkedIn' },
  { value: 'Advertisement', label: 'Advertisement' },
  { value: 'Portal', label: 'Portal' },
  { value: 'Other', label: 'Other' }
];

export const CONFIRMATION_SWITCH = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
];

export const DROPDOWN_LABEL = {
  ALL_EMPLOYEE: 'All Employee',
  ALL_DEPARTMENT: 'All Department',
  ALL_DESIGNATION: 'All Designation',
  ALL_VALUE: '-1'
};
